export enum ShipmentTimeFilter {
  EstimatedDepartureTimeLoad = 'estimatedDepartureTimeLoad',
  EstimatedArrivalTimeLoad = 'estimatedArrivalTimeLoad',
  ActualDepartureTimeLoad = 'actualDepartureTimeLoad',
  ActualArrivalTimeLoad = 'actualArrivalTimeLoad',
  PlannedDepartureTimeLoad = 'plannedDepartureTimeLoad',
  PlannedArrivalTimeLoad = 'plannedArrivalTimeLoad',
  EstimatedDepartureTimeTOAndWaybill = 'estimatedDepartureTimeTOAndWaybill',
  EstimatedArrivalTimeTOAndWaybill = 'estimatedArrivalTimeTOAndWaybill',
  ActualDepartureTimeTOAndWaybill = 'actualDepartureTimeTOAndWaybill',
  ActualArrivalTimeTOAndWaybill = 'actualArrivalTimeTOAndWaybill',
  PlannedDepartureTimeTOAndWaybill = 'plannedDepartureTimeTOAndWaybill',
  PlannedArrivalTimeTOAndWaybill = 'plannedArrivalTimeTOAndWaybill',
  ArrivalTime = 'arrivalTime',
  DepartureTime = 'departureTime',
}
